import useSWR from 'swr';
import {
  EMPTY_DETAILS,
  YoutubeVideoDetails,
} from 'utils/getYoutubeVideoDetails';

const POLL_INTERVAL_MS = 30000;

const fetcher = (url: string): Promise<YoutubeVideoDetails> =>
  fetch(url).then((res) => res.json());

export function useYoutubeVideoDetails(videoId: string): YoutubeVideoDetails {
  const { data } = useSWR<YoutubeVideoDetails>(
    `/api/youtube-video-details?videoId=${videoId}`,
    fetcher,
    { refreshInterval: POLL_INTERVAL_MS }
  );

  return data ?? EMPTY_DETAILS;
}

export default useYoutubeVideoDetails;
